(() => {
  class SheRocksPersonalHelp extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-contact-config]').textContent);
      this.intent = this.querySelector('[data-intent]');
      this.params = new URLSearchParams(location.search);
      const requested = this.params.get('intent') || this.dataset.defaultIntent;
      this.intent.value = Object.hasOwn(this.config.intents, requested) ? requested : 'general';
      this.querySelector('[data-source]').value = (this.params.get('source') || this.dataset.defaultSource || 'contact-page').replace(/[^a-zA-Z0-9_/-]/g, '').slice(0, 150);
      this.updateProductContext();
      this.shortlist = '';
      const picks = this.params.get('picks');
      if (picks && /^\d(?:\.\d){6}$/.test(picks)) {
        const resultsUrl = new URL('/pages/gift-finder', location.origin);
        resultsUrl.searchParams.set('picks', picks);
        this.querySelector('[data-quiz-link]').href = resultsUrl.pathname + resultsUrl.search;
        try {
          const stored = JSON.parse(sessionStorage.getItem('sr-gift-quiz-shortlist'));
          if (stored?.picks === picks && typeof stored.summary === 'string') this.shortlist = stored.summary.slice(0, 18000);
        } catch (_) {}
        if (!this.shortlist) this.shortlist = this.config.quizFallback + '\n' + resultsUrl.toString();
        this.querySelector('[data-shortlist]').value = this.shortlist;
      }
      this.intent.addEventListener('change', () => {
        const url = new URL(location.href);
        url.searchParams.set('intent', this.intent.value);
        history.replaceState(null, '', url);
        this.update();
      });
      this.querySelector('[data-preferred]').addEventListener('change', () => this.updatePhone());
      this.update();
    }
    updateProductContext() {
      const context = this.querySelector('[data-product-context]');
      const title = (this.params.get('product') || '').replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, 500);
      const rawUrl = this.params.get('product_url');
      if (!context || !title || !rawUrl) return;
      let productUrl;
      try {
        productUrl = new URL(rawUrl, location.origin);
      } catch (_) {
        return;
      }
      if (productUrl.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9][a-z0-9-]*\/?$/i.test(productUrl.pathname)) return;
      const variant = productUrl.searchParams.get('variant');
      productUrl.search = '';
      productUrl.hash = '';
      if (variant && /^\d+$/.test(variant)) productUrl.searchParams.set('variant', variant);
      const options = (this.params.get('options') || '').replace(/[\u0000-\u0008\u000b-\u001f\u007f]/g, '').trim().slice(0, 2000);
      context.querySelector('[data-inquiry-product]').value = title;
      context.querySelector('[data-inquiry-product-text]').textContent = title;
      context.querySelector('[data-inquiry-url]').value = productUrl.toString();
      context.querySelector('[data-inquiry-link]').href = productUrl.pathname + productUrl.search;
      context.querySelector('[data-inquiry-options]').value = options;
      context.querySelector('[data-inquiry-options-text]').textContent = options;
      context.querySelector('[data-inquiry-options]').disabled = !options;
      context.querySelector('[data-inquiry-options-row]').hidden = !options;
      context.hidden = false;
      context.disabled = false;
    }
    updatePhone() {
      const required = this.querySelector('[data-preferred]').value === 'phone';
      this.querySelector('[data-phone]').required = required;
      this.querySelector('[data-phone-label]').textContent = this.config.phone + (required ? ' *' : ` (${this.config.optional})`);
    }
    update() {
      const key = this.intent.value;
      const content = this.config.intents[key];
      this.querySelector('[data-title]').textContent = content.title;
      this.querySelector('[data-intro]').textContent = content.intro;
      this.querySelector('[data-message-label]').textContent = content.message;
      this.querySelector('[data-message]').placeholder = content.placeholder;
      this.querySelector('[data-submit]').textContent = content.button + ' ↗';
      this.querySelectorAll('[data-for]').forEach(group => {
        const visible = group.dataset.for.split(' ').includes(key);
        group.hidden = !visible;
        group.disabled = !visible;
      });
      const quiz = this.querySelector('[data-quiz]');
      quiz.hidden = !(key === 'gift' && this.shortlist);
      quiz.disabled = quiz.hidden;
      this.updatePhone();
    }
  }
  if (!customElements.get('sr-personal-help')) customElements.define('sr-personal-help', SheRocksPersonalHelp);
})();
